"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'share.conversation.loading': 'Loading conversation...',
    'share.conversation.noIdProvided': 'No conversation ID provided',
    'share.conversation.failedToLoad': 'Failed to load conversation',
    'share.conversation.untitled': 'Untitled Conversation',
    'share.conversation.linkCopied': 'Link copied to clipboard',
    'share.conversation.linkCopyFailed': 'Failed to copy link',
    'share.conversation.copyLink': 'Copy Link',
    'share.conversation.goToChat': 'Go to Chat',
    'share.conversation.you': 'You',
    'share.conversation.assistant': 'Assistant',
    'share.conversation.reasoning': 'Reasoning',
    'share.conversation.thoughts': 'Thoughts',
    'share.conversation.sources': 'Sources',
    'share.conversation.toolsUsed': 'Tools Used',
    'share.conversation.noMessages': 'No messages found',
    'share.conversation.noMessagesDescription': 'This conversation appears to be empty or the messages could not be loaded.',
    'share.conversation.footerNote': 'This is a shared conversation. You can start your own chat to interact with the AI.',
    'share.conversation.startNewChat': 'Start New Chat',
    'share.conversation.unknownModel': 'Unknown Model',
    'share.conversation.unknownFile': 'Unknown file',
    'share.conversation.unknownSize': 'Unknown size',
};
